'use strict';

export default function f($q, $ocLazyLoad, $state, $rootScope, modal, guideStatus, alert, trips,
                          userModel, offerMessage, lastOfferMessage, membershipModal, analyticsSa) {
  'ngInject';

  return {
    sendOffer(isFilledSettings, offer) {
      var promise = new $q((resolve, reject) => {
        reject();
      });

      const CLICK_TRACK = 'click-sendOffer';
      analyticsSa.track({action: CLICK_TRACK, data: {userId: userModel.item.id}});

      if (guideStatus.isUnverifiedGuide() && !isFilledSettings) {
        alert.show({
          header: 'SEND_OFFER_MODAL.NOT_VERIFIED.HEADER',
          body: 'SEND_OFFER_MODAL.NOT_VERIFIED.BODY',
          buttons: [
            {
              label: 'SEND_OFFER_MODAL.NOT_VERIFIED.LABEL',
              action: 'accept'
            }
          ]
        }).then(() => {
          $state.go('settings');
        });
        return promise;
      } else if (guideStatus.isInactiveGuide()) {
        return alert.show({
          header: 'SEND_OFFER_MODAL.NOT_ACTIVE.HEADER',
          body: 'SEND_OFFER_MODAL.NOT_ACTIVE.BODY',
          buttons: [
            {
              label: 'SEND_OFFER_MODAL.NOT_ACTIVE.LABEL',
              action: 'accept'
            }
          ]
        }).then(() => {
          guideStatus.becomeGuide();
          return this.open(offer);
        });
      }
      else if (userModel.item.id > 10151546 && userModel.item.isActiveGuide &&
               userModel.item.location && userModel.item.location.name === 'Dubai' && !userModel.hasMembership()) {
        return membershipModal(offer.user.id).then(() => {
          return this.open(offer);
        });
      }
      else if (userModel.item.id > 10195550 && userModel.item.isActiveGuide &&
        userModel.item.location && userModel.item.location.countryCode === 'TR' && !userModel.hasMembership()) {
        return membershipModal(offer.user.id).then(() => {
          return this.open(offer);
        });
      }
      else if (userModel.item.askToBuyMembersipOnTripOffer && !userModel.hasMembership()) {
        return membershipModal(offer.user.id).then(() => {
          return this.open(offer);
        });
      }
      else {
        return this.open(offer);
      }
    },

    open(offer) {
      var offerMessagePromise = $q((resolve) => {
        var lastOfferMessageContent = lastOfferMessage.getMessage();
        if (lastOfferMessageContent) {
          resolve(lastOfferMessageContent);
        } else {
          offerMessage.getMessage(userModel.item.id, offer.user.id).then((response) => {
            offerMessage.receivedMessage = response.data.message;
            resolve(response.data.message);
          });
        }
      });

      var modalPromise = $q((resolve) => {
        import('./send_offer_modal').then(() => {
          $ocLazyLoad.load({
            name: 'components.saSendOfferModal'
          });

          trips.offer.tripId = offer.id;
          trips.offer.visitorId = offer.user.id;
          trips.offer.trip = offer;

          resolve();
        });
      });

      var promises = [modalPromise, offerMessagePromise];

      return $q.all(promises).then((result) => {
        trips.offer.trip.message = result[1];

        return $q((resolve) => {
          resolve(modal.open({
            template: '<sa-send-offer-modal offer="offer" done="close()"></sa-send-offer-modal>'
          }));
        });
      });
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/components/trips/trips/send_offer_modal/send_offer_modal.service.js